import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card-header border-0 pt-5" }
const _hoisted_2 = { class: "card-title align-items-start flex-column" }
const _hoisted_3 = { class: "card-label fw-bolder fs-3 mb-1" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted mt-1 fw-bold fs-7" }, "Você pode adicionar até 10 sites", -1)
const _hoisted_5 = {
  key: 0,
  class: "card-toolbar btn-gap"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-sm btn-success",
  type: "button",
  "data-bs-toggle": "modal",
  "data-bs-target": "#kt_modal_new_site"
}, "Adicionar site", -1)
const _hoisted_7 = { class: "card-body py-3" }
const _hoisted_8 = { class: "table-responsive" }
const _hoisted_9 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted text-uppercase bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "ps-4 min-w-300px rounded-start" }, "Nome"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px text-center" }, "Cookies"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px text-center" }, "Visualizações"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-200px text-center" }, "Consentimentos"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px text-center" }, "Progresso"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px text-end rounded-end" })
  ])
], -1)
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "d-flex align-items-center" }
const _hoisted_13 = { class: "symbol symbol-50px me-5" }
const _hoisted_14 = { class: "symbol-label bg-light" }
const _hoisted_15 = { class: "d-flex justify-content-start flex-column" }
const _hoisted_16 = { class: "d-flex align-items-center" }
const _hoisted_17 = { class: "text-muted fw-bold text-muted d-block fs-7" }
const _hoisted_18 = { class: "text-center" }
const _hoisted_19 = { class: "text-dark fw-bolder text-hover-primary d-block mb-1 fs-6" }
const _hoisted_20 = { class: "text-center" }
const _hoisted_21 = { class: "text-dark fw-bolder text-hover-primary d-block mb-1 fs-6" }
const _hoisted_22 = { class: "text-center" }
const _hoisted_23 = { class: "text-dark fw-bolder text-hover-primary d-block mb-1 fs-6" }
const _hoisted_24 = { class: "text-center" }
const _hoisted_25 = { class: "text-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_steps_progress = _resolveComponent("steps-progress")!
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["card", _ctx.widgetClasses])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h3", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, "Sites (" + _toDisplayString(_ctx.total) + ")", 1),
          _hoisted_4
        ]),
        (_ctx.actions)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _hoisted_6,
              _createVNode(_component_router_link, {
                class: "btn btn-sm btn-primary",
                to: "/sites"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Ver todos")
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("table", _hoisted_9, [
            _hoisted_10,
            (_ctx.tableRows)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_11, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableRows, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.initials(item.name || item.website)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_15, [
                            _createVNode(_component_router_link, {
                              class: "text-dark fw-bolder text-hover-primary mb-1 fs-6",
                              to: { name: 'siteDetails', params: { id: item._id} }
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_16, [
                                  _createElementVNode("span", null, _toDisplayString(item.name), 1),
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["badge fw-bolder", item.status.account == 'active' ? 'badge-light-success' : 'badge-light-danger']),
                                    style: {"margin-left":"1rem"}
                                  }, _toDisplayString(_ctx.getBadgeLabel(item.status.account)), 3)
                                ])
                              ]),
                              _: 2
                            }, 1032, ["to"]),
                            _createElementVNode("span", _hoisted_17, _toDisplayString(item.website), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_18, [
                        _createElementVNode("span", _hoisted_19, _toDisplayString(item.stats.cookies), 1)
                      ]),
                      _createElementVNode("td", _hoisted_20, [
                        _createElementVNode("span", _hoisted_21, _toDisplayString(item.stats.views), 1)
                      ]),
                      _createElementVNode("td", _hoisted_22, [
                        _createElementVNode("span", _hoisted_23, _toDisplayString(item.stats.consents), 1)
                      ]),
                      _createElementVNode("td", _hoisted_24, [
                        _createVNode(_component_steps_progress, { progress: item }, null, 8, ["progress"])
                      ]),
                      _createElementVNode("td", _hoisted_25, [
                        _createVNode(_component_router_link, {
                          class: "btn btn-bg-light btn-color-success btn-active-color-primary btn-md px-4 me-2",
                          to: { name: 'siteDetails', params: { id: item._id} }
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Acessar")
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ], 2),
    (_ctx.havePagination)
      ? (_openBlock(), _createBlock(_component_Pagination, {
          key: 0,
          pagination: _ctx.result,
          onChangePage: _ctx.newPage
        }, null, 8, ["pagination", "onChangePage"]))
      : _createCommentVNode("", true)
  ], 64))
}